import { LocalStorageClient } from 'core/infra/storage/LocalStorageClient'

import { MagicLinkUserRepository } from '../infra/MagicLinkUserRepository'

const storage = new LocalStorageClient()
const repository = new MagicLinkUserRepository({ storage })

export function saveMagicLinkToken(token: string) {
  repository.setLocalToken(token)
}

export function getMagicLinkToken() {
  return repository.getLocalToken()
}
